

<template>
  <div class="content_list">
    <div
      class="list_item"
      v-for="(item, index) in productLists"
      :key="index"
      @click="toDetails(item)"
    >
      <div class="image_box">
        <el-image
          class="item_img"
          v-if="item.thumb"
          :src="item.thumb"
          fit="contain"
        ></el-image>
        <img class="item_img" v-else src="../../../assets/kv.jpg" alt="" />
      </div>
      <div class="item_text1">
        {{ langSet == "cn" ? item.goodsName : item.en_product_name }}
      </div>
      <!-- <div class="item_text2 margin_bottom">{{langSet=='cn'? '产品类别：' + item.categoryNameCnEn.category_name:'Product Category：' + item.categoryNameCnEn.en_category_name }}</div> -->
    </div>
  </div>
</template>
<script>
export default {
  name: "product_list",
  props: ["productLists", "external"],
  data() {
    return {
      langSet: "",
    };
  },
  mounted() {
    this.langSet = this.$language;
  },
  methods: {
    //25.9.18 跳转详情 dxm
    toDetails(e) {
      this.$router.push({
        path: "/productDetails",
        query: {
          id: this.external == "product" ? e.product_id : e.id,
        },
      });
    },
  },
};
</script>
<style scoped lang="scss">
.content_list {
  display: flex;
  flex-wrap: wrap;
}
.list_item {
  padding: 15px;
  width: calc(100% / 6 - 17px);
  box-sizing: border-box;
  margin-right: 20px;
  margin-bottom: 20px;
  overflow: hidden;
  cursor: pointer;
  background: #f7f8fa;
  border-radius: 20px;
  transition: all 0.5s ease-in-out;
  &:nth-child(6n) {
    margin-right: 0;
  }
  &:hover {
    background: #e9eaf2;
  }
  .image_box {
    width: 100%;
    height: 166px;
    background: #f5f5f5;
    border-radius: 20px;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-bottom: 10px;
    overflow: hidden;
  }
  .item_img {
    width: 100% !important;
    height: 100% !important;
  }
  .item_text1 {
    font-weight: 500;
    font-size: 16px;
    color: #001a33;
    line-height: 22px;
    text-align: left;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    overflow: hidden;
  }
}

.item_text2 {
  font-weight: 400;
  font-size: 18px;
  color: #757575;
  line-height: 25px;
  text-align: left;
  font-style: normal;
}
.margin_bottom {
  width: 100%;
  margin-bottom: 12px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
@media only screen and (max-width: 1280px) {
  .list_item {
    width: calc(100% / 4 - 9px);
    margin-right: 10px;
    &:nth-child(6n) {
      margin-right: 10px;
    }
    &:nth-child(4n) {
      margin-right: 0;
    }
    .image_box {
      height: 166px;
      .item_img {
        width: 100% !important;
        height: 100% !important;
      }
    }
  }
}
@media only screen and (max-width: 767px) {
  .content_list {
    margin: 0;
    justify-content: space-between;
  }
  .list_item {
    height: 3.83rem;
    padding: 0.19rem;
    background: #f7f8fa;
    margin: 0 0.08rem 0.19rem;
    flex: 0 0 calc(50% - 0.19rem);
    &:nth-child(6n) {
      margin-right: 0 !important;
    }
    .image_box {
      height: 2.31rem;
      margin-bottom: 0.19rem;
      .item_img {
        width: 100% !important;
        height: 100% !important;
      }
    }
    .item_text1 {
      font-size: 0.29rem;
      line-height: 0.4rem;
    }
    .margin_bottom {
      margin-bottom: 0.1rem;
    }
    .item_text2 {
      margin-bottom: 0;
      font-size: 0.25rem;
      line-height: 0.35rem;
    }
  }
}
</style>